
import React from "react";

interface EBProps { onReset?: () => void; children?: React.ReactNode; }
interface EBState { hasError: boolean; error: unknown; }

export default class ErrorBoundary extends React.Component<EBProps, EBState> {
  constructor(props: EBProps) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: unknown) {
    return { hasError: true, error };
  }

  componentDidCatch(error: unknown, errorInfo: React.ErrorInfo) {
    console.error("[ErrorBoundary]", error, errorInfo);
  }

  handleReload = () => {
    if (this.props.onReset) this.props.onReset();
    this.setState({ hasError: false, error: null });
    try { window.location.reload(); } catch(_) {}
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
          minHeight: "100vh", padding: 24, gap: 12, textAlign: "center"
        }}>
          <h2>Algo salió mal</h2>
          <p>Ocurrió un error inesperado al renderizar esta pantalla. Puedes recargar para intentar de nuevo.</p>
          <button onClick={this.handleReload} style={{
            padding: "8px 16px", borderRadius: 8, border: "1px solid #ccc", cursor: "pointer"
          }}>Recargar</button>
          {process.env.NODE_ENV !== 'production' && !!this.state.error && (
            <pre style={{textAlign: "left", background: "#f8f8f8", padding: 12, borderRadius: 8, maxWidth: 800, overflow: "auto"}}>
{String((this.state.error as any)?.stack || (this.state.error as any)?.message || this.state.error)}
            </pre>
          )}
        </div>
      );
    }
    return this.props.children;
  }
}
